document.addEventListener("DOMContentLoaded", function () {
  // Check if the ratings text slider element exists
  var ratingsSliderElement = document.getElementById("ratingsTextSlider");
  if (ratingsSliderElement) {

    var splide = new Splide("#ratingsTextSlider", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: false, // Disable default arrows
      drag: true,
      rewind: false, // Prevent looping
      speed: 400, // Smooth transition speed
    }).mount();

    // On live, WP Rocket loads Splide's core CSS non-render-blocking
    // (media="print" onload="this.media='all'"), so the layout rules that
    // Splide relies on (flex list, slide widths) may not be applied yet when
    // we mount on DOMContentLoaded. That makes Splide measure the wrong slide
    // dimensions and every navigation lands on a shifted position. Re-measure
    // once the stylesheet, fonts and images have settled so positions are
    // recalculated against the final layout. refresh() is cheap and idempotent.
    function refreshSplide() {
      splide.refresh();
    }
    window.addEventListener("load", refreshSplide);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshSplide);
    }
    // Belt-and-braces: if the async Splide stylesheet flips to media="all"
    // after we mounted, re-measure when it finishes loading.
    var splideCss = document.getElementById("splide-css-css");
    if (splideCss && !splideCss.sheet) {
      splideCss.addEventListener("load", refreshSplide);
    }

    var prevButton = document.getElementById("prevSlide");
    var nextButton = document.getElementById("nextSlide");

    // Check if navigation buttons exist
    if (!prevButton || !nextButton) {
      return; // Exit early if buttons don't exist
    }

    // Function to update button states
    function updateButtons() {
      prevButton.classList.toggle("disabled", splide.index === 0);
      nextButton.classList.toggle("disabled", splide.index === splide.length - 1);
    }

    // Initial check when the slider loads
    updateButtons();

    // Listen for slide change event
    splide.on("moved", function () {
      updateButtons();
    });

    // Custom navigation buttons
    prevButton.addEventListener("click", function () {
      splide.go("<");
    });

    nextButton.addEventListener("click", function () {
      splide.go(">");
    });
  }
});
